export const ESCOLARIDADES = [
    { id: "Pós-Doutorado", name: "Pós-Doutorado" },
    { id: "Doutorado", name: "Doutorado" },
    { id: "Mestrado", name: "Mestrado" },
    { id: "Especialização", name: "Especialização" },
    { id: "Graduação", name: "Graduação" },
    { id: "Técnico", name: "Técnico" },
    { id: "Outros", name: "Outros" },
];

export const ICT_STATUS_OPTIONS = [
    { id: "Em elaboração do Descritivo", name: "Em elaboração do Descritivo" },
    { id: "Ativo",      name: "Ativo" },
    { id: "Finalizado", name: "Finalizado" },
];

export const TIPO_PROJETO_OPTIONS = [
    { id: "Hardware", name: "Hardware" },
    { id: "Hardware com Software Embarcado", name: "Hardware com Software Embarcado" },
    { id: "Software", name: "Software" },
    { id: "Software Aplicativo", name: "Software Aplicativo" },
    { id: "Melhoria de Processo Produtivo", name: "Melhoria de Processo Produtivo" },
    { id: "Formação e Capacitação Profissional", name: "Formação e Capacitação Profissional" },
    { id: "Outro (Especificar)", name: "Outro (Especificar)" },
];

export const ALCANCE_PROJETO_OPTIONS = [
    { id: "Na Instituição", name: "Na Instituição" },
    { id: "Na Empresa", name: "Na Empresa" },
    { id: "No Mercado Interno", name: "No Mercado Interno" },
    { id: "Exportação", name: "Exportação" },
];

export const ABRANGENCIA_INOVACAO_OPTIONS = [
    { id: "Novo para a empresa, mas existente no mercado nacional", name: "Novo para a empresa, mas existente no mercado nacional" },
    { id: "Novo no mercado nacional, mas já existente no mercado mundial", name: "Novo no mercado nacional, mas já existente no mercado mundial" },
    { id: "Novo no mercado mundial", name: "Novo no mercado mundial" }
];

export const DESENVOLVIMENTO_INOVACAO_OPTIONS = [
    { id: "Aprimoramentos a partir de algo existente", name: "Aprimoramentos a partir de algo existente" },
    { id: "Desenvolvimento de algo novo", name: "Desenvolvimento de algo novo" }
];

export const ARTIGO_24_OPTIONS = [
    { id: "I", name: "I - Trabalho teórico ou experimental realizado de forma sistemática para adquirir novos conhecimentos, visando a atingir objetivo específico, descobrir novas aplicações ou obter ampla e precisa compreensão dos fundamentos subjacentes aos fenômenos e fatos observados, sem prévia definição para o aproveitamento prático dos resultados" },
    { id: "II", name: "II - Trabalho sistemático utilizando o conhecimento adquirido na pesquisa ou experiência prática, para desenvolver novos materiais, produtos, dispositivos ou programas de computador, para implementar novos processos, sistemas ou serviços ou, então, para aperfeiçoar os já produzidos ou implantados, incorporando características inovadoras" },
    { id: "III", name: "III - Serviço científico e tecnológico de assessoria, consultoria, estudos, ensaios, metrologia, normalização, gestão tecnológica, fomento à invenção e inovação, gestão e controle da propriedade intelectual gerada dentro das atividades de pesquisa e desenvolvimento, bem como implantação e operação de incubadoras de base tecnológica em tecnologias da informação, desde que associadas a quaisquer das atividades previstas nos incisos I e II deste artigo" },
    { id: "IV-a", name: "IV - a) Formação ou capacitação profissional de níveis médio e superior para aperfeiçoamento e desenvolvimento de recursos humanos em tecnologias da informação" },
    { id: "IV-b", name: "IV - b) Formação ou capacitação profissional de níveis médio e superior para aperfeiçoamento e desenvolvimento de recursos humanos envolvidos nas atividades de que tratam os incisos de I a III deste artigo" },
    { id: "IV-c", name: "IV - c) Formação ou capacitação profissional de níveis médio e superior em cursos de formação profissional, de nível superior e de pós-graduação, observado o disposto no inciso III do art. 27" },
    { id: "IV-1", name: "IV - § 1º) Admitir-se-á o intercâmbio científico e tecnológico, internacional e inter-regional, como atividade complementar à execução de projeto de pesquisa e desenvolvimento, para fins do disposto no art. 8º" }
];

export const PI_TIPO_OPTIONS = [
    { id: "Patente de Invenção", name: "Patente de Invenção" },
    { id: "Modelo de Utilidade", name: "Modelo de Utilidade" },
    { id: "Registro de Software", name: "Registro de Software" },
    { id: "Marca", name: "Marca" },
    { id: "Desenho Industrial", name: "Desenho Industrial" },
    { id: "Outros", name: "Outros" }
];
export const REGIOES_OPTIONS = [
    { id: "N/NE/CO Pública",  name: "N/NE/CO Pública" },
    { id: "N/NE/CO Privada",  name: "N/NE/CO Privada" },
    { id: "Demais Regiões",   name: "Demais Regiões" },
];

export const MODO_LANCAMENTO_OPTIONS = [
    { id: "anual",  name: "Anual" },
    { id: "mensal", name: "Mensal" },
];
